/*
  Collection grid: endless scroll (House Of Elegance)
  The whole collection (up to 250 products) is rendered by the server with
  in-stock products first and sold-out products last. Only the first batch
  is visible; the next batch appears automatically as the shopper nears the
  bottom (or taps "Load more"). Once everything is shown the button is
  removed. Re-initialises after filters/sorting update the grid.
*/
(function () {
  function init(root) {
    if (root.dataset.infiniteInit) return;
    var grid = root.querySelector('#product-grid');
    var more = root.querySelector('.pg-more');
    if (!grid || !more) return;
    root.dataset.infiniteInit = '1';

    var batch = parseInt(more.dataset.batch, 10) || 20;
    var total = parseInt(more.dataset.total, 10) || 0;
    var btn = more.querySelector('.pg-more__btn');
    var shownEl = more.querySelector('[data-shown]');
    var bar = more.querySelector('.pg-more__bar span');
    var io = null;

    function remaining() {
      return grid.querySelectorAll('.grid__item.pg-deferred');
    }

    function update() {
      var left = remaining().length;
      var visible = total - left;
      if (shownEl) shownEl.textContent = visible;
      if (bar) bar.style.width = (total ? (visible / total) * 100 : 100) + '%';
      if (!left) {
        more.classList.add('is-done');
        if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
        btn = null;
        if (io) io.disconnect();
      }
    }

    function reveal() {
      var next = Array.prototype.slice.call(remaining(), 0, batch);
      next.forEach(function (li) {
        li.classList.remove('pg-deferred');
      });
      update();
    }

    if (btn) btn.addEventListener('click', reveal);

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          if (!entries[0].isIntersecting) return;
          reveal();
          io.unobserve(more);
          requestAnimationFrame(function () {
            if (remaining().length) io.observe(more);
          });
        },
        { rootMargin: '0px 0px 700px 0px' }
      );
      io.observe(more);
    }

    update();
  }

  function initAll() {
    document.querySelectorAll('.collection-infinite').forEach(init);
  }

  function watchGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !('MutationObserver' in window)) return;
    new MutationObserver(initAll).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      watchGrid();
    });
  } else {
    initAll();
    watchGrid();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
